<template>
  <div class="certifi-container">
    <div class="form-item">
      <div class="input-box"><input v-model="equipmentNumber" :placeholder="$t('placeholder.equipmentNumber')" /></div>
    </div>
    <div class="form-item">
      <div class="input-box">
        <input v-model="verificationCode" :placeholder="$t('placeholder.verificationCode')" />
        <img :src="captchaImage" @click="handleSwitch" />
      </div>
    </div>
    <button class="certifi-btn" type="default" @click="onSearch">{{ $t("button.search") }}</button>
    <div class="example-dia">
      <div class="example-text">{{ $t("example.title") }}:</div>
      <img class="example-img" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/new-website/exam-img.png" />
      <div class="example-desc">
        <img class="icon-exam" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/new-website/icon-exam.png" />
        <div class="example-title">{{ $t("example.howToGet") }}</div>
      </div>
      <div class="desc-text">
        {{ $t("example.descLeft") }}<span>{{ $t("example.descRight") }}</span>
      </div>
    </div>
    <van-dialog width="95%" :confirmButtonText="$t('dialog.sure')" id="van-dialog" v-model="dialogVisible">
      <div class="show-certifi" v-if="certifiInfo">
        <img class="h-logo" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/new-website/h-logo.png" />
        <img class="equip-img" :src="certifiInfo.thumbnail" />
        <div class="certifi-tip">
          <div class="cert-text">{{ $t("dialog.certified") }}</div>
          <div class="off-cert">
            <span>{{ $t("dialog.certNumber") }}：</span>
            <span>{{ certifiInfo.certificationNumber }}</span>
          </div>
          <div class="off-cert">
            <span>{{ $t("dialog.certDate") }}：</span>
            <span v-if="$i18n.locale == 'zh_CN'">{{ certifiInfo.certificationDate }}</span>
            <span v-else>{{ certifiInfo.certificationMonth }}/{{ certifiInfo.certificationDay }}/{{ certifiInfo.certificationYear }} </span>
          </div>
        </div>
        <div class="row-info">
          <div class="label-group">
            <div class="gray-label">{{ $t("dialog.workingHours") }}：</div>
            <div class="gray-value">{{ certifiInfo.workingHours }}h</div>
          </div>
          <div class="label-group">
            <div class="gray-label">{{ $t("dialog.serialNumber") }}：</div>
            <div class="gray-value">{{ certifiInfo.equipmentNumber }}</div>
          </div>
        </div>
        <div class="row-info">
          <div class="label-group">
            <div class="gray-label">{{ $t("dialog.warranty") }}：</div>
            <div class="gray-value">{{ certifiInfo.warranty == 1 ? $t("dialog.yes") : $t("dialog.no") }}</div>
          </div>
          <div class="label-group" v-if="certifiInfo.modelName">
            <div class="gray-label">{{ $t("dialog.model") }}：</div>
            <div class="gray-value">{{ certifiInfo.modelName }}</div>
          </div>
        </div>
        <div class="row-stamp">
          <div class="row-section">
            <div :class="['section-item', $i18n.locale == 'ar_ST' ? 'item-dis' : '']">
              <span>{{ $t("dialog.chassisRenewal") }}：</span>
              <span>{{ certifiInfo.chassisSystemRenewalRate }}%</span>
            </div>
            <div :class="['section-item', $i18n.locale == 'ar_ST' ? 'item-dis' : '']">
              <span>{{ $t("dialog.genuineParts") }}：</span>
              <span>{{ certifiInfo.genuineSanyParts == 1 ? $t("dialog.yes") : $t("dialog.no") }}</span>
            </div>
          </div>
          <span class="stamp-text">{{ $t("dialog.stamp") }}</span>
          <span class="arrow">▶</span>
          <img src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/new-website/cert-logo.png" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: "certifi",
  components: {},
  data() {
    return {
      channel: "", //来源ID
      equipmentNumber: "", //设备编号
      verificationCode: "", //图形验证码
      captchaId: "", //验证码ID
      dialogVisible: false, //对话框是否可见
      certifiInfo: null, //认证信息
      captchaImage: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/new-website/cert-code.png" // 验证码图片
    }
  },
  created() {
    console.log("query", this.$route.query)
    this.channel = this.$route.query.channel || ""
    const langParam = this.$route.query.lang || this.$route.query.Lang || "zh_CN"
    const supported = [
      "zh_CN",
      "en_US",
      "th_TH",
      "id_ID",
      "ru_RU",
      "km_KH",
      "it_IT",
      "es_ES",
      "pt_PT",
      "fr_FR",
      "ar_ST",
      "de_DE",
      "ko_KR",
      "vi_VN",
      "ms_MY"
    ]
    if (supported.includes(langParam)) {
      this.$i18n.locale = langParam
    }
    document.title = this.$t("title")
    this.handleSwitch() //获取图形验证码
  },
  methods: {
    handleSwitch() {
      this.$api.renZhengCaptcha().then(({ data }) => {
        this.captchaId = data.data.captchaId
        this.captchaImage = data.data.image
      })
    },
    onSearch() {
      if (this.equipmentNumber == "") {
        this.$toast({ message: this.$t("toast.emptyEquipment"), position: "top" })
        return
      }
      if (this.verificationCode == "") {
        this.$toast({ message: this.$t("toast.emptyCaptcha"), position: "top" })
        return
      }
      const params = {
        channelCode: this.channel,
        equipmentNumber: this.equipmentNumber,
        captchaId: this.captchaId,
        verificationCode: this.verificationCode
      }
      this.$api.certificationSearch({ ...params }).then((data) => {
        if (data.data.code == 0) {
          if (data.data.data) {
            this.equipmentNumber = ""
            this.verificationCode = ""
            this.certifiInfo = data.data.data
            this.dialogVisible = true
          } else {
            this.$toast({ message: this.$t("dialog.noCer"), position: "top" })
          }
        } else {
          this.$toast({ message: data.data.msg, position: "top" })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.certifi-container {
  width: 100%;
  height: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
  .form-item {
    margin-bottom: 20px;
    .input-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        width: 100%;
        height: 45px;
        font-size: 16px;
        border-radius: 18px;
        border: none;
        background: #f4f5f9;
        padding: 6px 12px;
        box-sizing: border-box;
        &::placeholder {
          color: #999999;
          font-size: 14px;
          opacity: 0.7;
        }
      }
      img {
        width: 120px;
        height: 45px;
        border-radius: 4px;
        margin-left: 30px;
      }
    }
  }
  .certifi-btn {
    width: 100%;
    border: none;
    color: #fff;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    border-radius: 8px;
    background: #e53935;
  }
  .example-dia {
    width: 100%;
    height: 100%;
    background: #f4f5f9;
    margin-top: 30px;
    border-radius: 8px;
    padding: 15px;
    box-sizing: border-box;
    .example-text {
      font-size: 16px;
      color: #5c5c5e;
    }
    .example-img {
      width: 100%;
      height: 140px;
      object-fit: fill;
      margin-top: 12px;
    }
    .example-desc {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .icon-exam {
        width: 20px;
        height: 20px;
      }
      .example-title {
        font-size: 16px;
        color: #5c5c5e;
        font-weight: bold;
        margin-left: 6px;
      }
    }
    .desc-text {
      font-size: 13px;
      color: #5c5c5e;
      line-height: 1.8;
      margin-top: 10px;
      span {
        color: #25324c;
        font-weight: bold;
      }
    }
  }
  .show-certifi {
    padding: 5px 10px 0;
    box-sizing: border-box;
    .h-logo {
      width: 100%;
      height: 25px;
      object-fit: contain;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .equip-img {
      width: 100%;
      height: 180px;
      display: block;
      object-fit: cover;
      border-radius: 10px;
    }
    .certifi-tip {
      display: flex;
      flex-direction: column;
      background: #e90000;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 10px;
      margin-top: 8px;
      .cert-text {
        font-size: 12px;
        color: #fff;
        line-height: 1.2;
        margin-bottom: 5px;
      }
      .off-cert {
        display: flex;
        align-items: center;
        margin-top: 6px;
        span {
          font-size: 12px;
          color: #fff;
        }
      }
    }
    .row-info {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 8px;
      .label-group {
        width: 46%;
        display: flex;
        align-items: center;
        .gray-label {
          width: 70px;
          font-size: 12px;
          font-weight: bold;
        }
        .gray-value {
          min-width: 80px;
          font-size: 10px;
          font-weight: bold;
          background: #f4f5f9;
          padding: 2px 6px;
          box-sizing: border-box;
          text-align: center;
        }
      }
    }
    .row-stamp {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #b5b4b5;
      padding: 0 5px;
      box-sizing: border-box;
      margin-top: 10px;
      .row-section {
        flex: 1;
        .section-item {
          span {
            font-size: 12px;
            color: #b5b4b5;
            &:nth-child(2) {
              color: #090404;
            }
          }
        }
        .item-dis {
          display: flex;
          align-items: center;
        }
      }
      .stamp-text {
        font-size: 12px;
        color: #b5b4b5;
        margin-left: 5px;
      }
      .arrow {
        font-size: 12px;
        color: #b5b4b5;
        margin-left: 2px;
      }
      img {
        width: 60px;
        height: 60px;
      }
    }
  }
}
</style>
